import * as React from "react";
import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Layout } from "../Layout/Layout";
import { Content } from "../Content/Content";
import { authStore } from "../../mobx/stores/AuthStore/AuthStore";

export const MainPage = observer(() => {
  const { me } = authStore;
  const [openDrawer, setOpenDrawer] = useState(true);

  useEffect(() => {
    me();
  }, []);

  return (
    <Layout>
      <Layout.Header open={openDrawer} onDrawerOpen={() => setOpenDrawer(true)} />
      <Layout.Body>
        <Content open={openDrawer} onDrawerClose={() => setOpenDrawer(false)} />
      </Layout.Body>
    </Layout>
  );
});
